import { AnyAction } from 'redux';

import {
  TICKETS_RECEIVED,
  TICKETS_RECEIVE_DONE,
  TICKETS_RECEIVE_FAILED,
  TICKETS_REQUESTED,
} from '@ttstr/actions/tickets';
import { Articles } from '@ttstr/api';

export interface ReduxState {
  loading: boolean;
  tickets: Articles;
  ticketsReceived: boolean;
  error: Error;
}

const initialState: ReduxState = {
  loading: false,
  tickets: [],
  ticketsReceived: false,
  error: null,
};

const tickets = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case TICKETS_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case TICKETS_RECEIVED: {
      const { tickets } = action.payload;

      return {
        ...state,
        ticketsReceived: true,
        tickets,
      };
    }
    case TICKETS_RECEIVE_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        error,
      };
    }
    case TICKETS_RECEIVE_DONE: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default tickets;
